import AddUser from "components/User/AddUser";
import User from "components/User/User";
import React from "react";
import { Route, Switch } from "react-router-dom";

export default function Users() {
  return (
    <div className="flex flex-wrap mt-4">
      <div className="w-full mb-12 px-4">
        <Switch>
          <Route exact path="/admin/users" component={User} />
          <Route exact path="/admin/users/add" component={AddUser} />
        </Switch>
      </div>
    </div>
  );
}
